export type CookiePolicySection = {
  id: string;
  title: string;
  paragraphs?: string[];
  subsections?: {
    title: string;
    paragraphs: string[];
    list?: string[];
  }[];
  list?: string[];
  contact?: {
    label: string;
    value: string;
    href?: string;
  }[];
};

export const cookiePolicySections: CookiePolicySection[] = [
  {
    id: 'intro',
    title: 'Giriş',
    paragraphs: [
      'BALIKESİR GÜVEN ÖZEL SAĞLIK LABORATUVAR HİZMETLERİ LTD. ŞTİ. (“Şirket”) olarak, Health Shop Longevity internet sitesi (“Web Sitesi”) kullanıcılarının deneyimini geliştirmek, Web Sitesinin güvenli ve düzgün şekilde çalışmasını sağlamak ve gerekli durumlarda site kullanımına ilişkin istatistiksel analizler yapmak amacıyla çerezler ve benzeri teknolojiler kullanabiliriz.',
      'Bu Çerez Politikası, Web Sitesinde kullanılan çerezlerin hangi amaçlarla kullanıldığını ve kullanıcıların çerez tercihlerini nasıl yönetebileceğini açıklamaktadır.',
    ],
  },
  {
    id: 'what-is-cookie',
    title: '1. Çerez Nedir?',
    paragraphs: [
      'Çerezler (cookies), internet sitelerini ziyaret ettiğinizde bilgisayarınız, tabletiniz veya mobil cihazınızda saklanabilen küçük veri dosyalarıdır.',
      'Çerezler, Web Sitesinin düzgün çalışmasına yardımcı olabilir, tercihlerinizi hatırlayabilir ve site kullanımının analiz edilmesini sağlayabilir.',
    ],
  },
  {
    id: 'cookie-types',
    title: '2. Çerez Türleri',
    paragraphs: [
      'Web Sitesinde kullanılan çerezler amaçlarına göre aşağıdaki şekilde sınıflandırılabilir:',
    ],
    subsections: [
      {
        title: 'Zorunlu Çerezler',
        paragraphs: [
          'Bu çerezler Web Sitesinin temel işlevlerinin çalışabilmesi için gerekli olabilir.',
          'Örneğin;',
          'Bu çerezler devre dışı bırakıldığında Web Sitesinin bazı bölümleri veya temel işlevleri düzgün çalışmayabilir.',
        ],
        list: [
          'alışveriş sepetinin çalışması',
          'oturumun yönetilmesi',
          'güvenliğin sağlanması',
          'ödeme ve sipariş işlemlerinin yürütülmesi',
          'kullanıcı tercihlerinin teknik olarak uygulanması',
        ],
      },
      {
        title: 'İşlevsel Çerezler',
        paragraphs: [
          'Bu çerezler kullanıcı tercihlerini hatırlamak ve Web Sitesinin kullanımını kişiselleştirmek amacıyla kullanılabilir.',
          'Örneğin dil, bölge veya kullanıcı tarafından seçilen bazı site tercihleri bu çerezler aracılığıyla hatırlanabilir.',
        ],
      },
      {
        title: 'Analitik / Performans Çerezleri',
        paragraphs: [
          'Bu çerezler Web Sitesinin nasıl kullanıldığını anlamak, ziyaretçi ve sayfa görüntülenme istatistiklerini analiz etmek, teknik sorunları tespit etmek ve Web Sitesinin performansını geliştirmek amacıyla kullanılabilir.',
          'Bu tür çerezler, gerekli olduğu durumlarda kullanıcının tercihleri doğrultusunda etkinleştirilir.',
        ],
      },
      {
        title: 'Pazarlama / Reklam Çerezleri',
        paragraphs: [
          'Bu çerezler, kullanıcının ilgi alanlarına yönelik reklam ve pazarlama faaliyetlerinin yürütülmesi, reklamların ölçümlenmesi veya reklam kampanyalarının etkinliğinin değerlendirilmesi amacıyla kullanılabilir.',
          'Bu tür çerezler, gerekli olduğu durumlarda kullanıcının açık tercihine/rızasına tabi tutulur.',
        ],
      },
    ],
  },
  {
    id: 'third-party',
    title: '3. Üçüncü Taraf Çerezleri',
    paragraphs: [
      'Web Sitesinde ödeme hizmetleri, analiz hizmetleri, güvenlik hizmetleri veya diğer teknik hizmetler için üçüncü taraf hizmet sağlayıcıların teknolojileri kullanılabilir.',
      'Bu kapsamda üçüncü taraf hizmet sağlayıcılar kendi çerezlerini veya benzer teknolojileri kullanabilir.',
      'Kullanılan üçüncü taraf hizmetler ve ilgili çerezler, Web Sitesinde aktif olarak kullanılan hizmetlere göre güncellenebilir.',
    ],
  },
  {
    id: 'manage-preferences',
    title: '4. Çerez Tercihlerinin Yönetilmesi',
    paragraphs: [
      'Web Sitesini ilk ziyaretinizde, zorunlu olmayan çerezlere ilişkin tercihlerinizi çerez tercih paneli üzerinden yönetebilirsiniz.',
      'Kullanıcı;',
      'Daha sonra çerez tercihlerinizi Web Sitesindeki “Çerez Tercihleri” alanından değiştirebilirsiniz.',
      'Tarayıcı ayarlarınız üzerinden de çerezleri engellemeniz veya silmeniz mümkündür. Ancak bazı çerezlerin devre dışı bırakılması Web Sitesinin belirli işlevlerinin düzgün çalışmamasına neden olabilir.',
    ],
    list: [
      'zorunlu olmayan çerezleri kabul edebilir',
      'reddedebilir',
      'çerez kategorilerine göre tercihlerini belirleyebilir',
    ],
  },
  {
    id: 'retention',
    title: '5. Çerezlerin Saklama Süresi',
    paragraphs: [
      'Çerezlerin saklama süreleri kullanılan çerezin türüne ve amacına göre değişebilir.',
      'Bazı çerezler tarayıcı oturumunun sona ermesiyle otomatik olarak silinirken bazı çerezler belirli bir süre boyunca cihazınızda tutulabilir.',
      'Kullanılan çerezlerin saklama süreleri, ilgili çerezlerin teknik özelliklerine göre belirlenir.',
    ],
  },
  {
    id: 'personal-data',
    title: '6. Kişisel Verilerin İşlenmesi',
    paragraphs: [
      'Çerezler aracılığıyla kişisel veri işlenmesi halinde, ilgili kişisel veriler 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) ve ilgili mevzuata uygun şekilde işlenir.',
      'Kişisel verilerin işlenmesine ilişkin ayrıntılı bilgiler KVKK Aydınlatma Metni içerisinde açıklanmaktadır.',
      'Çerezler aracılığıyla gerçekleştirilen veri işleme faaliyetlerinde gerekli hukuki şartlar uygulanır.',
    ],
  },
  {
    id: 'change-preferences',
    title: '7. Çerez Tercihlerinin Değiştirilmesi',
    paragraphs: [
      'Kullanıcı, Web Sitesinde sunulan çerez tercih mekanizması aracılığıyla daha önce verdiği tercihleri değiştirebilir veya geri çekebilir.',
      'Çerez tercihleri geri çekildiğinde, ilgili çerezlerin kullanılmasına son verilir. Ancak daha önce hukuka uygun şekilde gerçekleştirilmiş veri işleme faaliyetleri bu durumdan geriye dönük olarak etkilenmez.',
    ],
  },
  {
    id: 'updates',
    title: '8. Politikanın Güncellenmesi',
    paragraphs: [
      'Şirket, Web Sitesinde kullanılan çerezlerde veya ilgili mevzuatta meydana gelen değişiklikler doğrultusunda bu Çerez Politikasını güncelleyebilir.',
      'Güncel politika Web Sitesinde yayımlandığı tarihten itibaren geçerli olur.',
    ],
  },
  {
    id: 'contact',
    title: '9. Veri Sorumlusu ve İletişim Bilgileri',
    contact: [
      {
        label: 'Unvan',
        value: 'BALIKESİR GÜVEN ÖZEL SAĞLIK LABORATUVAR HİZMETLERİ LTD. ŞTİ.',
      },
      {
        label: 'Adres',
        value: 'Bahçelievler Mah. Atatürk Cad. Erdem Sitesi No: 10 B Altıeylül / Balıkesir',
      },
      {
        label: 'Telefon',
        value: '+90 553 538 24 62',
        href: 'tel:+905535382462',
      },
      {
        label: 'E-posta',
        value: 'guvenozelsaglik@gmail.com',
        href: 'mailto:guvenozelsaglik@gmail.com',
      },
      {
        label: 'KEP',
        value: 'balikesirguvenozel@hs06.kep.tr',
        href: 'mailto:balikesirguvenozel@hs06.kep.tr',
      },
      {
        label: 'MERSİS No',
        value: '[Eklenecek]',
      },
    ],
  },
];

export const cookieCategories = [
  {
    id: 'essential' as const,
    name: 'Zorunlu Çerezler',
    description:
      'Web Sitesinin temel işlevlerinin çalışması için gereklidir. Sepet, oturum ve güvenlik gibi işlevler bu çerezlere bağlıdır.',
    required: true,
  },
  {
    id: 'functional' as const,
    name: 'İşlevsel Çerezler',
    description:
      'Dil, bölge ve kullanıcı tercihlerinizi hatırlayarak site deneyimini kişiselleştirir.',
    required: false,
  },
  {
    id: 'analytics' as const,
    name: 'Analitik / Performans Çerezleri',
    description:
      'Ziyaretçi istatistikleri ve site performansını analiz etmek için kullanılır.',
    required: false,
  },
  {
    id: 'marketing' as const,
    name: 'Pazarlama / Reklam Çerezleri',
    description:
      'İlgi alanlarınıza yönelik reklam ve pazarlama faaliyetleri için kullanılır.',
    required: false,
  },
];
